import { cn } from "@/lib/utils";

/**
 * Stord Innkvartering logo mark: 3x3 module grid (squares + quarter circles) with one brand-blue circle.
 * Paths extracted from the official negative logo. `color` controls the module color (defaults to currentColor).
 */
export const BrandMark = ({ className, color = "currentColor", accent = "#2670F2", title = "Stord Innkvartering" }) => (
  <svg viewBox="0 0 148 150" className={cn("h-8 w-8", className)} role="img" aria-label={title} data-testid="brand-mark">
    {/* row 1 */}
    <path fill={color} d="M0 45.8h44.6V1.2A44.6 44.6 0 0 0 0 45.8Z" />
    <circle fill={accent} cx="73.7" cy="23.5" r="23.5" />
    <rect fill={color} x="102.8" y="1.2" width="44.6" height="44.6" />
    {/* row 2 */}
    <path fill={color} d="M0 52.6a44.6 44.6 0 0 0 44.6 44.6V52.6Z" />
    <rect fill={color} x="51.4" y="52.6" width="44.6" height="44.6" />
    <path fill={color} d="M102.8 52.6v44.6h44.6a44.6 44.6 0 0 0-44.6-44.6Z" />
    {/* row 3 */}
    <rect fill={color} x="0" y="104" width="44.6" height="44.6" />
    <rect fill={color} x="51.4" y="104" width="44.6" height="44.6" />
    <path fill={color} d="M102.8 148.6a44.6 44.6 0 0 0 44.6-44.6h-44.6Z" />
  </svg>
);

/** Mark + wordmark. `tone` = "dark" (on light surfaces, default) | "light" (on dark surfaces) */
export const BrandLogo = ({ className, tone = "dark", subtitle, size = "md" }) => {
  const fg = tone === "light" ? "text-white" : "text-navy";
  const sub = tone === "light" ? "text-white/60" : "text-muted-foreground";
  const dims = size === "lg" ? "h-10 w-10" : size === "sm" ? "h-5 w-5" : "h-7 w-7";
  const text = size === "lg" ? "text-lg" : size === "sm" ? "text-[13px]" : "text-[14px]";
  return (
    <div className={cn("flex items-center gap-2", fg, className)} data-testid="brand-logo">
      <BrandMark className={dims} />
      <div className="leading-tight">
        <div className={cn("font-semibold tracking-tight text-foreground", text)}>Stord Innkvartering</div>
        {subtitle && <div className={cn("text-[11px]", sub)}>{subtitle}</div>}
      </div>
    </div>
  );
};
